import { render, staticRenderFns } from "./PathwayCohortViewAddStudent.vue?vue&type=template&id=6c3d975c&"
import script from "./PathwayCohortViewAddStudent.vue?vue&type=script&lang=js&"
export * from "./PathwayCohortViewAddStudent.vue?vue&type=script&lang=js&"
import style0 from "./PathwayCohortViewAddStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports